import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
import { createIconSetFromIcoMoon } from "@expo/vector-icons";
import * as Font from "expo-font";
import axios from "axios";

const selectionJsonUrl = "https://cdn.vdbapp.com/vdb2/icons/selection.json";
const iconMoonIconUrl = "https://cdn.vdbapp.com/vdb2/icons/icomoon.ttf";

const FONT_FAMILY = "vdb";
const REQUEST_TIMEOUT_MS = 10000;

let cachedIconSet: any = null;
let cachedPromise: Promise<any> | null = null;
let icomoonFontInjected = false;

const injectIcomoonFontDisplay = () => {
  if (Platform.OS !== "web" || icomoonFontInjected) return;
  icomoonFontInjected = true;
  const style = document.createElement("style");
  style.id = "icomoon-font-display";
  style.textContent = `
    @font-face {
      font-family: 'vdb';
      src: url('${iconMoonIconUrl}') format('truetype');
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
};

const VDBCustomIcon = (props: any) => {
  const [, setReady] = useState(false);

  useEffect(() => {
    injectIcomoonFontDisplay();
    if (cachedIconSet) return;

    let cancelled = false;

    if (!cachedPromise) {
      cachedPromise = axios
        .get(selectionJsonUrl, { timeout: REQUEST_TIMEOUT_MS })
        .then(async (res) => {
          if (!res.data?.icons) {
            throw new Error("Invalid IcoMoon JSON: missing 'icons' array");
          }

          await Font.loadAsync({
            [FONT_FAMILY]: iconMoonIconUrl,
          });

          cachedIconSet = createIconSetFromIcoMoon(
            res.data,
            FONT_FAMILY,
            iconMoonIconUrl
          );
        })
        .catch((err) => {
          cachedPromise = null; // allow retry on next mount
          console.error("VDBCustomIcon: failed to load icon font", err);
          throw err;
        });
    }

    cachedPromise
      .then(() => {
        if (!cancelled) {
          setReady((r) => !r);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  if (!cachedIconSet) return null;

  const IconSet = cachedIconSet;
  return <IconSet {...props} />;
};

export default VDBCustomIcon;
